
<script>
import http from '@/service/http'
import findIndex from 'lodash/findIndex'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'Receber',
  data () {
    return {
      list: [],
      filterList: [],
      busca: '',
      filtro: {
        inicio: moment().format('YYYY-MM-DD'),
        termino: moment().format('YYYY-MM-DD'),
        conta: '',
        busca: ''
      },
      totais: {
        geral: 0,
        pago: 0,
        atrasado: 0,
        hoje: 0,
        pendente: 0
      },
      show: {
        totais: false,
        filtro: false
      },
      contas: [],
      pago: [],
      status: 'geral'
    }
  },
  mounted () {
    this.fecth()
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    chipAtraso (data) {
      var vencimento = moment(data).format('YYYY-MM-DD')
      var hoje = moment().format('YYYY-MM-DD')
      if (hoje > vencimento) {
        return true
      }
    },
    chipHoje (data) {
      var hoje = moment().format('YYYY-MM-DD')
      if (data === hoje) {
        return true
      }
    },
    async fecth () {
      const { data } = await http.get(`/financeiro/receber`)
      if (data != null) {
        this.list = data.rows.data
        this.filterList = data.rows.data
        this.filtro = data.filtro
        this.totais = data.totais
        this.contas = data.contas
      }
      setTimeout(function () {
        window.Materialize.updateTextFields()
      }, 0)
    },
    async filtrar () {
      this.busca = ''
      const { data } = await http.get(`financeiro/receber?inicio=${this.filtro.inicio}&termino=${this.filtro.termino}&conta=${this.filtro.conta}&busca=${this.filtro.busca}`)
      this.list = data.rows.data
      this.filterList = data.rows.data
      this.filtro = data.filtro
      this.totais = data.totais
      this.contas = data.contas
      this.changeStatus(this.status)
    },
    async updateList (obj) {
      this.filtrar()
      window.Materialize.toast('Registro salvo com sucesso!!', 4000)
    },
    destroy (receber) {
      this.$swal({
        title: `Deseja remover ${receber.descricao}?`,
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(async () => {
        const { data } = await http.delete(`/financeiro/receber/${receber.id}`)
        if (data != null) {
          const index = await findIndex(this.filterList, { id: receber.id })
          if (index > -1) {
            this.filterList.splice(index, 1)
            window.Materialize.toast('Registro removido com sucesso!!', 4000)
          }
        }
      })
    },
    pagamentoMassa () {
      http.post('/financeiro/receber/massa', this.pago)
      .then(data => {
        this.pago = []
        this.busca = ''
        this.fecth()
      })
    },
    changeStatus (status) {
      this.status = status
      this.filterList = this.list.filter((item) => {
        if (status === 'geral') {
          return item.id
        }
        if (status === 'pago') {
          return item.pago
        }
        if (status === 'pendente') {
          return !item.pago
        }
        if (status === 'hoje') {
          return this.chipHoje(item.vencimento)
        }
        if (status === 'atrasado') {
          return this.chipAtraso(item.vencimento) && !item.pago
        }
      })
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapGetters(['permissoes']),
    showBtNovo () {
      return this.$route.name === 'financeiro-receber.index'
    },
    showBtVoltar () {
      return this.$route.name === 'financeiro-receber.form'
    },
    hasItens () {
      return this.filterList.length > 0
    }
  }
}
</script>

<template>
	<div>

    <div class="content">

      <div class="row">
        <div class="col s12 m11">
          <h5>Financeiro :: Contas a Receber <span v-show="!busca && !loading && showBtNovo">{{ formatDate(filtro.inicio) }} a {{ formatDate(filtro.termino) }}</span></h5>
        </div>
        <div class="col s12 m1 input-field right-align">
          <router-link :to="{ name: 'financeiro-receber.form' }" v-show="showBtNovo && permissoes.indexOf('financeiro-receber.inserir') > -1" class="btn-floating btn-large waves-effect waves-light"><i class="material-icons">add</i></router-link>
          <router-link :to="{ name: 'financeiro-receber.index' }" v-show="showBtVoltar" class="btn-floating btn-large waves-effect waves-light red"><i class="material-icons">close</i></router-link>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <router-view @update-financeiro-receber-list="updateList"></router-view>
        </div>
      </div>

      <!--<div class="row" v-show="showBtNovo">-->
        <!--<div class="col s12">-->
          <!--&lt;!&ndash;<button class="btn-floating waves-effect waves-light" @click.prevent="show.filtro = !show.filtro"><i class="material-icons">filter_list</i></button>&ndash;&gt;-->
          <!--<button class="btn-floating waves-effect waves-light" @click.prevent="show.totais = !show.totais"><i class="material-icons">monetization_on</i></button>-->
        <!--</div>-->
      <!--</div>-->

      <div class="row" v-show="showBtNovo">
        <div class="col s12 m10">
          <form @submit.prevent="filtrar">
            <div class="row">
              <div class="input-field col s12 m2">
                <i class="material-icons prefix">event</i>
                <input id="icon_inicio" type="date"  v-model="filtro.inicio" :data-value="filtro.inicio">
                <label for="icon_inicio" class="active">Início</label>
              </div>

              <div class="input-field col s12 m2">
                <i class="material-icons prefix">event</i>
                <input id="icon_termino" type="date" v-model="filtro.termino"
                       :data-value="filtro.termino">
                <label for="icon_termino" class="active">Término</label>
              </div>

              <div class="col s12 m2">
                <label for="filtro_conta">Conta Bancária</label>
                <select name="conta" id="filtro_conta" v-model="filtro.conta">
                  <option v-for="conta in contas" :value="conta.id">{{ (conta.id) ? conta.conta : 'Todas' }}</option>
                </select>
              </div>

              <div class="input-field col s12 m3">
                <input id="busca" type="text" v-model="filtro.busca">
                <label for="busca">Buscar</label>
              </div>

              <div class="input-field col s12 m1">
                <button class="waves-effect waves-light btn">Filtrar</button>
                <label></label>
              </div>

              <div class="input-field col s12 m3">
                <a class="waves-effect waves-light btn blue" href="https://sistemakgb.com.br/integracao/conta-azul" target="_blank">Sync Conta Azul</a>
                <label></label>
              </div>

            </div>
          </form>
        </div>
      </div>

      <!--<div class="row" v-show="show.totais && showBtNovo">-->
      <div class="row" v-show="showBtNovo">

        <div class="col s12 m2">
          <div class="card pointer blue-grey darken-1" @click="changeStatus('geral')">
            <div class="card-content white-text">
              <span class="card-title">Geral <i v-show="status === 'geral'" class="material-icons">check_circle</i></span>
              <p>R$ {{ totais.geral }}</p>
            </div>
          </div>
        </div>

        <div class="col s12 m2">
          <div class="card pointer green accent-4" @click="changeStatus('pago')">
            <div class="card-content white-text">
              <span class="card-title">Pago <i v-show="status === 'pago'" class="material-icons">check_circle</i></span>
              <p>R$ {{ totais.pago }}</p>
            </div>
          </div>
        </div>

        <div class="col s12 m2">
          <div class="card pointer amber darken-4" @click="changeStatus('pendente')">
            <div class="card-content white-text">
              <span class="card-title">Pendente <i v-show="status === 'pendente'" class="material-icons">check_circle</i></span>
              <p>R$ {{ totais.pendente }}</p>
            </div>
          </div>
        </div>

        <div class="col s12 m2">
          <div class="card pointer amber accent-4" @click="changeStatus('hoje')">
            <div class="card-content white-text">
              <span class="card-title">Hoje <i v-show="status === 'hoje'" class="material-icons">check_circle</i></span>
              <p>R$ {{ totais.hoje }}</p>
            </div>
          </div>
        </div>

        <div class="col s12 m2">
          <div class="card pointer deep-orange accent-3" @click="changeStatus('atrasado')">
            <div class="card-content white-text">
              <span class="card-title">Atrasado <i v-show="status === 'atrasado'" class="material-icons">check_circle</i></span>
              <p>R$ {{ totais.atrasado }}</p>
            </div>
          </div>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'financeiro-receber.atrasados', params: { geral: 'geral' } }" tag="div" class="card pointer deep-orange accent-4">
            <div class="card-content white-text">
              <span class="card-title">Atras. Geral</span>
              <p>R$ {{ totais.atrasadoGeral }}</p>
            </div>
          </router-link>
        </div>

      </div>

      <div class="center-align" v-show="showBtNovo && !hasItens && !loading">
        <p>Nenhum registro encontrado!</p>
      </div>

      <div class="row z-depth-1" v-show="showBtNovo && hasItens">
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
              <tr>
                <th>Vencimento</th>
                <th>Descrição</th>
                <th>R$ Receber</th>
                <th></th>
                <th class="right-align">Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="receber in filterList">
                <td>{{ formatDate(receber.vencimento) }}</td>
                <td>
                  <router-link :to="{ name: 'financeiro-receber.form', params: { id: receber.id } }" v-if="permissoes.indexOf('financeiro-receber.editar') > -1">{{ receber.descricao }}</router-link>
                  <span v-else>{{ receber.descricao }}</span>
                  {{ (receber.parcela !== '1/1') ? receber.parcela : '' }}<br />
                  <small>{{ receber.cliente ? receber.cliente.cliente : '' }} {{ receber.cliente && receber.conta ? '|' : '' }} {{ receber.conta ? receber.conta.conta : '' }}</small>
                </td>
                <td>{{ receber.valor_pago }}</td>
                <td class="right-align">
                  <span class="new badge green" v-if="receber.pago" data-badge-caption="pago"></span>
                  <span class="new badge red" v-if="!receber.pago && chipAtraso(receber.vencimento)" data-badge-caption="atrasado"></span>
                  <span class="new badge orange" v-if="!receber.pago && chipHoje(receber.vencimento)" data-badge-caption="vence hoje"></span>
                </td>
                <td class="right-align">
                  <input type="checkbox" :id="receber.id" v-model="pago" :value="receber.id" v-if="!receber.pago && permissoes.indexOf('financeiro-receber.editar') > -1" /><label :for="receber.id"></label>
                  <router-link :to="{ name: 'financeiro-receber.form', params: { id: receber.id } }" v-show="permissoes.indexOf('financeiro-receber.editar') > -1"><i class="material-icons blue-text">edit</i></router-link>
                  <a href="#" @click.prevent="destroy(receber)" v-show="permissoes.indexOf('financeiro-receber.excluir') > -1">
                    <i class="material-icons red-text">delete_forever</i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-show="pago.length > 0 && showBtNovo && hasItens" style="position: fixed; bottom: 10px; width: 100%;">
        <div class="col s12 center-align">
          <a class="waves-effect waves-light btn" @click.prevent="pagamentoMassa()"><i class="material-icons left">refresh</i> definir item(s) como pagos</a>
        </div>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/financeiro/receber/index.vue